"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.4;\n  > span {\n    display: block;\n  }\n  > span.change {\n    display: inline-block;\n    white-space: nowrap;\n    &.change-positive {\n      color: ", ";\n    }\n    &.change-negative {\n      color: ", ";\n    }\n    &.change-neutral {\n      color: ", ";\n    }\n  }\n  > strong {\n    display: inline-block;\n    margin-right: 5px;\n  }\n  &.size-normal {\n    > span {\n      font-size: 14px;\n    }\n    > span.change {\n      font-size: 12px;\n    }\n    > strong {\n      font-size: 20px;\n    }\n  }\n  &.size-large {\n    > span {\n      font-size: 20px;\n    }\n    > span.change {\n      font-size: 16px;\n    }\n    > strong {\n      font-size: 30px;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  > div {\n    padding: 0 10px;\n    flex-grow: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverviewStat = exports.OverviewStats = void 0;

var icons_1 = require("@ant-design/icons");

var react_1 = __importStar(require("react"));

var styledTypes_1 = require("./styledTypes");

var OverviewStatsContainer = styledTypes_1.styled.div(_templateObject());

function OverviewStats(props) {
  return react_1.default.createElement(OverviewStatsContainer, Object.assign({}, props), props.children);
}

exports.OverviewStats = OverviewStats;
var OverviewStatContainer = styledTypes_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@green'];
}, function (props) {
  return props.theme['@red'];
}, function (props) {
  return props.theme['@gray-7'];
});

function OverviewStat(_ref) {
  var name = _ref.name,
      value = _ref.value,
      colorKey = _ref.colorKey,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      change = _ref.change,
      changeNumber = _ref.changeNumber,
      style = _ref.style;
  var theme = (0, react_1.useContext)(styledTypes_1.ThemeContext);
  var changeContent = null;

  if (changeNumber !== undefined) {
    if (changeNumber > 0) {
      changeContent = react_1.default.createElement("span", {
        className: 'change change-positive'
      }, react_1.default.createElement(icons_1.CaretUpOutlined, null), " ", change);
    } else if (changeNumber < 0) {
      changeContent = react_1.default.createElement("span", {
        className: 'change change-negative'
      }, react_1.default.createElement(icons_1.CaretDownOutlined, null), " ", change);
    } else if (changeNumber === 0) {
      changeContent = react_1.default.createElement("span", {
        className: 'change change-neutral'
      }, react_1.default.createElement(icons_1.MinusOutlined, null), " No Change");
    }
  }

  return react_1.default.createElement(OverviewStatContainer, {
    className: "size-".concat(size),
    style: style
  }, react_1.default.createElement("span", null, name), react_1.default.createElement("strong", {
    style: {
      color: theme[colorKey]
    }
  }, value), changeContent);
}

exports.OverviewStat = OverviewStat;